import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    fetch,
    fetchRecords,
    update,
} from '../services/AccountsService.ts';


import {
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../../store/RecordsSliceCaseHelpers';
import {Account} from '../types';
import config from "../config";

const entityKey = config.entityKey;

interface AccountsState {
    byId: { [key: string]: Account },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as AccountsState;


const normalizeRecord = (record: Account) => {
    return Object.assign({}, record) as Account;
};

// generates pending, fulfilled and rejected
export const fetchAccounts = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    (filter?: { [key: string]: string }) => {

        return fetchRecords(filter)
            .then((response) => {
                if (response && response.items) {
                    return response.items.map((record: Account) => {
                        return record;
                    });
                }
                return [];
            });
    },
);

export const fetchAccount = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => response);
    });

export const saveAccount = createAsyncThunk(
    `${entityKey}/add`,
    (payload: Account) => {

        return add(payload)
            .then((response) => {
                if (response) {
                    return response;
                }
            });
    });

export const updateAccount = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: Account }) => {

        const normalized = Object.keys(record)
                                 .reduce((acc, key) => {
                                     if ((record as Record<string, unknown>)[key] !== undefined) {
                                         if (['email', 'created'].indexOf(key) === -1) {
                                             (acc as Record<string, unknown>)[key] = (record as Record<string, unknown>)[key];
                                         }
                                     }
                                     return acc;
                                 }, {} as Account);

        return update(id, normalized)
            .then((response) => {
                if (response) {
                    return normalizeRecord(record);
                }
            });
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchAccounts, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchAccount);

                                            // SAVE ONE
                                            saveOneCase(builder, saveAccount);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateAccount);

                                        },
                                    });

export default componentsSlice.reducer;
